import { render, staticRenderFns } from "./PurchaseRequisitionMaintain.vue?vue&type=template&id=610b3040&"
import script from "./PurchaseRequisitionMaintain.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisitionMaintain.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequisitionMaintain.vue?vue&type=style&index=0&id=610b3040&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610b3040')) {
      api.createRecord('610b3040', component.options)
    } else {
      api.reload('610b3040', component.options)
    }
    module.hot.accept("./PurchaseRequisitionMaintain.vue?vue&type=template&id=610b3040&", function () {
      api.rerender('610b3040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-requisition/PurchaseRequisitionMaintain.vue"
export default component.exports